import { Select } from 'foundations-components/transitional/components/Select';
import FilterInfoWarnings from '../common/FilterInfoWarnings';
import ConditionBox from '../common/ConditionBox';
import ConditionError from '../common/ConditionError';
import EditorConditionActionsContainer from './EditorConditionActionsContainer';
import EditorUIFieldSet from './EditorUIFieldSet';
import { TypeaheadResultsItem } from 'foundations-components/transitional/components/Typeahead';
import EditorConditionAsset from './EditorConditionAsset';
import { useAssetMembershipCondition } from '../../hooks/useAssetMembershipCondition';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const EditorAssetMembershipCondition = props => {
  const {
    condition,
    conditionPath,
    dataSeleniumInfo,
    filterFamily,
    inputUse,
    isNested
  } = props;
  const {
    fieldLabel,
    onConditionDelete,
    onSelectedOptionChange,
    operatorOptions
  } = useAssetMembershipCondition(filterFamily, condition, conditionPath);
  return /*#__PURE__*/_jsx(EditorConditionActionsContainer, {
    condition: condition,
    conditionPath: conditionPath,
    dataSeleniumInfo: dataSeleniumInfo,
    filterFamily: filterFamily,
    onConditionDelete: () => onConditionDelete(conditionPath),
    children: /*#__PURE__*/_jsx(ConditionBox, {
      isNestedOrHeader: isNested,
      children: /*#__PURE__*/_jsxs(EditorUIFieldSet, {
        legend: fieldLabel,
        children: [/*#__PURE__*/_jsx(View, {
          marginBlockEnd: "200",
          as: "div",
          children: /*#__PURE__*/_jsx(EditorConditionAsset, {
            condition: condition,
            filterFamily: filterFamily,
            inputUse: inputUse
          })
        }), /*#__PURE__*/_jsx(Select, {
          "data-selenium-info": dataSeleniumInfo,
          "data-selenium-test": "fr-filter-operator-select"
          //@ts-expect-error `userHasNoAccess` does not exist on `DSFieldRecordInstance`
          ,
          disabled: condition.field && condition.field.userHasNoAccess,
          onSelectedOptionChange: onSelectedOptionChange,
          optionRenderer: option => /*#__PURE__*/_jsx(TypeaheadResultsItem, {
            message: true,
            option: option
          }),
          options: operatorOptions,
          value: condition.constructor.toString(),
          buttonUse: inputUse === 'on-dark' ? 'form-on-dark' : undefined
        }), /*#__PURE__*/_jsx(ConditionError, {
          condition: condition
        }), /*#__PURE__*/_jsx(FilterInfoWarnings, {
          condition: condition
        })]
      })
    })
  });
};
export default EditorAssetMembershipCondition;